import { http } from '@/services/http_service';
export default {
    fetchItems(context)
    {
        return http()
        .post("/item/fetchItems")
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            console.log("아이템 확인",response.data);

            context.commit('setItems', response.data)

            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    itemView(context,data)
    {
        return http()
        .post("/item/itemView",data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)

            context.commit('setItemView', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    itemBuy(context, data)
    {
        return http()
        .post("/item/itemBuy",data)//itemId, user_id, user_name, bank_name, bank_num
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            return response.data;
        },function(error){
            //console.log(error.response.data)
            return error.response.data;
        });
    },
    //아이템 구매내역
    getBuyItems(context,data)
    {
        return http()
        .post("/item/itemBuyList?page="+data.page,data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            context.commit('setItemBuy', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    //아이템 사용내역
    itemUse(context,data)
    {
        return http()
        .post("/item/itemUse",data)//itemBuyId, count
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log('아이템 사용',response.data)
            //context.commit('setItemView', response.data)
            context.commit('updateItemBuy', response.data.itemBuy)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    //아이템 사용내역
    getItemUseList(context,data)
    {
        return http()
        .post("/item/itemUseList?page="+data.page,data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            context.commit('setItemUse', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    //현재 사용중인 아이템
    getItemValidity(context,data)
    {
        return http()
        .post("/item/itemValidity",data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            context.commit('setItemValidity', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },

    //아이템 유무
    ckItemValidity(context,data)
    {
        return http()
        .post("/item/ckItemValidity",data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },

    //아이템 만료 체크해서 삭제 처리
    deleteExpirationItem()
    {
        return http()
        .post("/item/deleteExpirationItem")//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
    //아이템 차감
    deductionItem(_,data)
    {
        return http()
        .post("/item/deduction",data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });    
    },
    //환불신청
    reqRefund(context,data)
    {
        return http()
        .post("/item/reqRefund",data)//itemBuyId, count
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log('환불신청',response.data)
            //context.commit('setItemView', response.data)
            context.commit('updateItemBuy', response.data.itemBuy)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
}
